export const isValid = (error: string | undefined, touched: boolean | undefined): boolean => {
    return !Boolean(typeof error === "string" && error !== "" && touched);
}